import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import UrlEditor from '@/components/text-editors/UrlEditor';

const DictionaryUriInput = ({
  text,
  protocol,
  maxLength,
  icon,
  size,
  fluid,
  onChange,
  onProtocolChange,
  className,
  type,
  error,
}) => {
  const intl = useIntl();
  return (
    <UrlEditor
      fluid={fluid}
      icon={icon}
      size={size}
      error={error}
      className={clsx('aridhia-dictionary-uri-input aridhia-is-edit-mode', className)}
      value={text || ''}
      protocol={protocol}
      maxLength={maxLength}
      placeholder={intl.formatMessage({ id: `dataset.dictionary.${type}.placeholder` })}
      onChange={(e, { value }) => { onChange(value); }}
      onProtocolChange={(e, { value }) => { onProtocolChange(value); }}
    />
  );
};

export default DictionaryUriInput;
